<template>
  <div>TABLET {{ $route.params.id }}</div>
</template>
<script>
export default {
  name: 'OrganizationView',
  params: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      accountType: '',
      isTabletOperationsEnabled: false
    }
  },
  async mounted() {
    const vm = this
  }
}
</script>
<style lang="scss"></style>
